module.exports = __webpack_public_path__ + "static/img/application8-4.16ffa8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application8-4.jpg
// module id = gBTM
// module chunks = 0